<div id="wrapper">
  <div id="chart-line">
    <div class="dotted-loader" [hidden]="graphDataSet"></div>
    <!-- <pre>{{ graphDataSet | json }}</pre> -->
    <!-- <pre>{{ chartOptions1 | json }}</pre> -->
    <div *ngIf="graphDataSet">
      <apx-chart
        [series]="chartOptions1?.series"
        [chart]="chartOptions1?.chart"
        [yaxis]="chartOptions1?.yaxis"
        [xaxis]="chartOptions1?.xaxis"
        [dataLabels]="chartOptions1?.dataLabels"
        [fill]="chartOptions1?.fill"
        [markers]="chartOptions1?.markers"
        [stroke]="chartOptions1?.stroke"
        [grid]="chartOptions1?.grid"
        [tooltip]="chartOptions1?.tooltip"
      ></apx-chart>
    </div>
    <!-- <apx-chart
      *ngIf="graphDataSet"
      [series]="chartOptions1?.series"
      [chart]="chartOptions1?.chart"
      [xaxis]="chartOptions1?.xaxis"
      [yaxis]="chartOptions1?.yaxis"
      [dataLabels]="chartOptions1?.dataLabels"
      [fill]="chartOptions1?.fill"
      [markers]="chartOptions1?.markers"
      [stroke]="chartOptions1?.stroke"
      [grid]="chartOptions1?.grid"
      [tooltip]="chartOptions1?.tooltip"
    ></apx-chart> -->
  </div>
</div>
